import * as React from "react";

export const ProductParkIcon = (props: { color: string }) => (
  <svg
    width={15}
    height={13}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.167 11.333H2.833V12a.667.667 0 0 1-.666.667H1.5A.667.667 0 0 1 .833 12V5.333l1.654-3.858A1.333 1.333 0 0 1 3.713.667h7.574a1.333 1.333 0 0 1 1.225.808l1.655 3.858V12a.667.667 0 0 1-.667.667h-.667a.667.667 0 0 1-.666-.667v-.667Zm.666-4.666H2.167V10h10.666V6.667ZM2.284 5.333h10.432L11.287 2H3.713L2.285 5.333h-.001Zm1.55 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7.333 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      fill={props.color}
    />
  </svg>
);
